import { NotReadySidePanel } from './NotReadySidePanel';
import { connectNotReadySidePanel } from './NotReadySidePanel.connect';

export const ConnectedNotReadySidePanel = connectNotReadySidePanel(NotReadySidePanel);
